import React from 'react';
import { Helmet } from 'react-helmet';
import { BookOpen } from 'lucide-react';
import GlobalNavbar from '@/components/GlobalNavbar';
import usePageMeta from '@/hooks/usePageMeta';
import LanguageHreflang from '@/components/LanguageHreflang';
import { useTranslation } from '@/hooks/useTranslation';

const ResearchPage = () => {
  const { t } = useTranslation();

  usePageMeta({
    title: t('research.titulo'),
    description: t('research.descricao'),
  });

  return (
    <div className="min-h-screen bg-[#F8FAFB] font-sans">
      <Helmet>
        <title>{t('research.titulo')} - PROVATIO</title>
      </Helmet>
      <LanguageHreflang />
      
      <GlobalNavbar />

      <section className="bg-[#1E3A8A] text-white text-center py-24 px-6 relative">
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="flex justify-center mb-6">
            <BookOpen className="w-16 h-16 text-[#D4AF37]" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight text-[#D4AF37]">
            {t('research.titulo')}
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            {t('research.descricao')}
          </p>
        </div>
      </section>

      <div className="h-2 w-full bg-[#D4AF37]"></div>

      <main className="flex flex-col items-center justify-center p-12 text-center">
        <div className="mt-8 p-8 rounded-xl border border-[#E5E7EB] bg-white max-w-md w-full shadow-md hover:border-[#D4AF37] transition-all">
          <h3 className="text-xl font-bold mb-3 text-[#1E3A8A]">{t('research.status')}</h3>
          <p className="text-sm text-[#6B7280]">{t('research.statusDesc')}</p>
        </div>
      </main>
    </div>
  );
};

export default ResearchPage;